import { Avatar, Flex, Spin } from "antd";
import dayjs from "dayjs";
import { isHTML, roleType } from "../../constants";
import { getSiteTheme, siteServiceLogo } from "../../utils";
import "./index.scss";

//对话内容
const ConversationContent = ({ messages, dialogueContentRef }: any) => {
  return (
    <div id="output-window-wrap" ref={dialogueContentRef}>
      <ul id="dialogue-box">
        {messages?.map((item: any, index: number) => {
          const isAssistant = [roleType.assistant, roleType.cs].includes(
            item.role
          );
          return (
            <li
              className={`dialogue-item ${
                isAssistant ? "dialogue-item-left" : "dialogue-item-right"
              }`}
              key={index}
            >
              <Flex vertical={isAssistant ? false : true} align="center">
                {item.role === roleType.user ? (
                  <>
                    <div className="dialogue-time">
                      {dayjs(item.create_time * 1000).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                    </div>
                    <div className="content">{item.message}</div>
                  </>
                ) : (
                  <>
                    <Avatar
                      size={32}
                      style={{ marginRight: 8, alignSelf: "flex-start" }}
                      src={
                        <img
                          src={
                            process.env.REACT_APP_AGENT_URL +
                              siteServiceLogo[
                                getSiteTheme(window.location.host)
                              ].aiAvatar ||
                            "https://api.dicebear.com/7.x/miniavs/svg?seed=1"
                          }
                          alt="avatar"
                        />
                      }
                    />
                    {/* 只加载最新一条消息 */}
                    {item.loading ? (
                      <Spin />
                    ) : isHTML(item.message) ? (
                      <div
                        className="content is-html"
                        dangerouslySetInnerHTML={{
                          __html: item.message,
                        }}
                      />
                    ) : (
                      <div className="content">{item.message}</div>
                    )}
                  </>
                )}
              </Flex>
              {/* {isAssistant && <LikeComponent />} */}
            </li>
          );
        })}
        {/* <li className="dialogue-item tootip-text">正在为您呼叫人工客服...</li> */}
        {/* <li className="dialogue-item tootip-text">正在为您转接...</li> */}
        {/* <li className="dialogue-item tootip-text">由于您长时间未回复消息，对话将在1分钟后结束</li> */}
        {/* <li className="dialogue-item tootip-text">当前对话已结束</li> */}
        {/* <li className="dialogue-item tootip-text">异常断开，正在为您重连</li> */}
        {/* <li className="dialogue-item tootip-text">已连接，请继续</li>  */}
      </ul>
    </div>
  );
};

export default ConversationContent;
